export const GTM_WISHLIST_LIST_NAME = 'wishlist';
export const GTM_WISHLIST_PAGE_TYPE = 'wishlist';
export const WISHLIST_PAGE_SIZE = 8;
export const WISHLIST_FIRST_PAGE_SIZE = 12;
export const SELECTION_MODE_HASH = '#selectionMode';
export const FILTERS_MIN_PRODUCTS_COUNT = 5;
